import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { Survivors } from './survivors'

const WrappedSurvivors = withLayout(LayoutType.NoPadding, Survivors)

export { WrappedSurvivors as Survivors }
